import Landscape1 from '../assets/refraction-landscapes/refraction-landscape-1.webp';
import Landscape2 from '../assets/refraction-landscapes/refraction-landscape-2.webp';
import Landscape3 from '../assets/refraction-landscapes/refraction-landscape-3.webp';

export const ibisVisionToolOptions = [
  {
    label: 'IbisVision V2',
    value: 'ibisV2',
    values: {
      selectValue: 'ibisV2',
      calibrationTriangleWidthInMm: 5,
      calibrationTriangleWidthInPx: 37,
      distanceCalibrationTriangleInMm: 130,
      distanceFrontTrianglesInMm: 38,
    },
  },
];

export const refractionStimulusBackgrounds = [
  { label: 'White background', value: 'white' },
  { label: 'Black background', value: 'black' },
  { label: 'Landscape 1', value: 'landscape1', media: Landscape1 },
  { label: 'Landscape 2', value: 'landscape2', media: Landscape2 },
  { label: 'Landscape 3', value: 'landscape3', media: Landscape3 },
];

export const refractionStimulusColorOptions = [
  { label: 'Yellow', value: 'yellow' },
  { label: 'Black', value: 'black' },
  { label: 'White', value: 'white' },
  { label: 'Green', value: 'green' },
];

export const colorFilters = {
  yellow: 'invert(93%) sepia(46%) saturate(6176%) hue-rotate(356deg) brightness(108%) contrast(106%)',
  green: 'invert(77%) sepia(54%) saturate(7287%) hue-rotate(84deg) brightness(124%) contrast(120%)',
  black: 'none',
  white: 'invert()',
};

export const refractionStimulusSizeOptions = [
  { label: '2mm', value: '2' },
  { label: '3mm', value: '3' },
  { label: '4mm', value: '4' },
  { label: '5mm', value: '5' },
  { label: '6mm', value: '6' },
  { label: '7mm', value: '7' },
  { label: '8mm', value: '8' },
  { label: '9mm', value: '9' },
  { label: '10mm', value: '10' },
];

export const refractionOptotypeOptions = [
  { label: 'Apple', value: 'apple' },
  { label: 'Boot', value: 'boot' },
  { label: 'Car', value: 'car' },
  { label: 'Duck', value: 'duck' },
  { label: 'House', value: 'house' },
  { label: 'Star', value: 'star' },
];

export const threshHoldOptions = [
  'THRESH_BINARY',
  // "THRESH_BINARY_INV",
  // "THRESH_TRUNC",
  // "THRESH_TOZERO",
  // "THRESH_TOZERO_INV",
  // "THRESH_OTSU",
  // "THRESH_TRIANGLE",
  // "ADAPTIVE_THRESH_MEAN_C",
  // "ADAPTIVE_THRESH_GAUSSIAN_C",
];

export const refractionAxisOptions = [
  { label: '12:00 - 06:00', value: '12:00 - 06:00', cylinder: '12:00 - 06:00' },
  { label: '12:15 - 06:15', value: '12:15 - 06:15', cylinder: '05:45 - 11:45' },
  { label: '12:30 - 06:30', value: '12:30 - 06:30', cylinder: '05:30 - 11:30' },
  { label: '12:45 - 06:45', value: '12:45 - 06:45', cylinder: '05:15 - 11:15' },
  { label: '01:00 - 07:00', value: '01:00 - 07:00', cylinder: '05:00 - 11:00' },
  { label: '01:15 - 07:15', value: '01:15 - 07:15', cylinder: '04:45 - 10:45' },
  { label: '01:30 - 07:30', value: '01:30 - 07:30', cylinder: '04:30 - 10:30' },
  { label: '01:45 - 07:45', value: '01:45 - 07:45', cylinder: '04:15 - 10:15' },
  { label: '02:00 - 08:00', value: '02:00 - 08:00', cylinder: '04:00 - 10:00' },
  { label: '02:15 - 08:15', value: '02:15 - 08:15', cylinder: '03:45 - 09:45' },
  { label: '02:30 - 08:30', value: '02:30 - 08:30', cylinder: '03:30 - 09:30' },
  { label: '02:45 - 08:45', value: '02:45 - 08:45', cylinder: '03:15 - 09:15' },
  { label: '03:00 - 09:00', value: '03:00 - 09:00', cylinder: '03:00 - 09:00' },
  { label: '03:15 - 09:15', value: '03:15 - 09:15', cylinder: '02:45 - 08:45' },
  { label: '03:30 - 09:30', value: '03:30 - 09:30', cylinder: '02:30 - 08:30' },
  { label: '03:45 - 09:45', value: '03:45 - 09:45', cylinder: '02:15 - 08:15' },
  { label: '04:00 - 10:00', value: '04:00 - 10:00', cylinder: '02:00 - 08:00' },
  { label: '04:15 - 10:15', value: '04:15 - 10:15', cylinder: '01:45 - 07:45' },
  { label: '04:30 - 10:30', value: '04:30 - 10:30', cylinder: '01:30 - 07:30' },
  { label: '04:45 - 10:45', value: '04:45 - 10:45', cylinder: '01:15 - 07:15' },
  { label: '05:00 - 11:00', value: '05:00 - 11:00', cylinder: '01:00 - 07:00' },
  { label: '05:15 - 11:15', value: '05:15 - 11:15', cylinder: '12:45 - 06:45' },
  { label: '05:30 - 11:30', value: '05:30 - 11:30', cylinder: '12:30 - 06:30' },
  { label: '05:45 - 11:45', value: '05:45 - 11:45', cylinder: '12:15 - 06:15' },
];

export const calculateRefractionResult = (distance1, distance2, distance3) => {
  const diopter1 = -1000 / distance1;
  const diopter2 = -1000 / distance2;
  const diopter3 = -1000 / distance3;

  const adjustment = 0.25;

  const m = (diopter1 + diopter2 + diopter3) / 3;

  const j1 = (2 * diopter1 - diopter2 - diopter3) / 3;

  const j2 = (diopter2 - diopter3) / Math.sqrt(3);

  const calcPow = Math.pow(j1, 2) + Math.pow(j2, 2);

  const sphere = m + Math.sqrt(calcPow);

  let cylinder = -2 * Math.sqrt(calcPow);

  const radian = 0.5 * Math.atan(j2 / j1);

  let axis = radian * (180 / Math.PI);

  //i.e the eye is becoming more myopic between 60 and 120 deg
  if (distance2 > distance3) {
    if (axis > 0) {
      axis = axis + 90;
    } else {
      axis = axis + 180;
    }
  } else if (distance2 < distance3) {
    if (axis < 0) {
      axis = axis + 90;
    }
  } else if (distance2 === distance3) {
    axis = 90;
    cylinder = 0;
  }

  return {
    sphere: Math.round((Math.round(sphere / adjustment) * adjustment + Number.EPSILON) * 100) / 100,
    cylinder: Math.round((Math.round(cylinder / adjustment) * adjustment + Number.EPSILON) * 100) / 100,
    axis: Math.round(axis > 0 ? axis : axis + 180),
  };
};

export const formattedRefractionScore = (score, decimalPlaces) => {
  if (score === 0) {
    if (decimalPlaces === 2) {
      return '0.00';
    }
    if (decimalPlaces === 0) {
      return '0';
    }
  }

  if (score === undefined || score === null || score === false) {
    return 'N/A';
  }

  return score.toFixed(decimalPlaces);
};
